import { useEffect, useRef } from 'react'

import { authInputClassName, authSecondaryClassName } from '../../constants/styles'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { useAppRouter } from '@/shared/lib/router'

import { AuthShell } from '../AuthShell'

import { SignInButton } from './Button'
import { SignInFields } from './Fields'
import { SignInForm } from './Form'

interface SignInProps {
  onSuccess?: () => void
}

export const SignIn = ({ onSuccess: _onSuccess }: SignInProps) => {
  const { setAction, callbackUrl } = useAuthContext()
  const router = useAppRouter()

  const emailRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    emailRef.current?.focus()
  }, [])

  const handleSignIn = (data: { ok: boolean }) => {
    // Navigate for real (not just close the modal): closing via a
    // search-param-only change on the same "/" route does not re-run
    // beforeLoad, so an authenticated user would otherwise stay stuck on
    // the landing page instead of reaching callbackUrl/jornadas.
    if (data.ok) {
      router.push(callbackUrl)
    }
  }

  return (
    <AuthShell title="Entrar" subtitle="Bem-vindo de volta ao Missão Futuro">
      <SignInForm onSignIn={handleSignIn} className="gap-4">
        <SignInFields
          inputClassName={authInputClassName}
          emailRef={emailRef}
          passwordRef={passwordRef}
        />
        <SignInButton>Fazer Login</SignInButton>
        <button
          type="button"
          className={authSecondaryClassName}
          onClick={() => setAction('sign-up')}
        >
          Criar Conta
        </button>
      </SignInForm>
    </AuthShell>
  )
}

export { SignInForm } from './Form'
export { SignInFields } from './Fields'
export { SignInButton } from './Button'
